export class CategoriaTrabajo {

    constructor (
        public _id ?: string,
        public nombre_es ?: string,
        public nombre_en ?: string,
        public desc_es ?: string,
        public desc_en ?: string,
        public parent ?: string,
        public childrens ?: CategoriaTrabajo[],
        public selected ?: boolean,
        public nivel ?: number,
        public tipoCategoriaTrabajo ?: string
    ) { }

}



// WEBPACK FOOTER //
// ./src/app/models/categoriaTrabajo.model.ts